import IntlMessages from "@richbeauty/utility/IntlMessages";
import { useIntl } from "react-intl";
import { AppInputType } from "shared/constants/AppEnums";

const useConvertToUserModalFieldsConfig = () => {
  const { messages } = useIntl();
  return [
    {
      type: AppInputType.TEXT,
      inputConfig: {
        placeholder: messages["app.users.username"],
      },
      formItemConfig: {
        name: "username",
        label: <IntlMessages id="app.users.username" />,
        rules: [{ required: true }],
      },
    },
    {
      type: AppInputType.PASSWORD,
      inputConfig: {
        placeholder: messages["app.users.password"] || "Password",
      },
      formItemConfig: {
        name: "password",
        label: <IntlMessages id="app.users.password" />,
        rules: [{ required: true }],
      },
    },
    {
      type: AppInputType.TEXT,
      inputConfig: {
        placeholder: messages["app.users.email"],
      },
      formItemConfig: {
        name: "email",
        label: <IntlMessages id="app.users.email" />,
        rules: [{ required: true, type: "email" }],
      },
    },
    {
      type: AppInputType.TEXT,
      inputConfig: {
        placeholder: messages["app.customerLeads.firstName"],
      },
      formItemConfig: {
        name: "firstName",
        label: <IntlMessages id="app.customerLeads.firstName" />,
        rules: [{ required: true }],
      },
    },
    {
      type: AppInputType.TEXT,
      inputConfig: {
        placeholder: messages["app.customerLeads.lastName"],
      },
      formItemConfig: {
        name: "lastName",
        label: <IntlMessages id="app.customerLeads.lastName" />,
        rules: [{ required: true }],
      },
    },
    {
      type: AppInputType.PHONE_NUMBER_INPUT,
      inputConfig: {
        placeholder: messages["app.customerLeads.phone"],
      },
      formItemConfig: {
        name: "phoneNumber",
        label: <IntlMessages id="app.customerLeads.phone" />,
      },
    },
    {
      type: AppInputType.DATE_PICKER,
      inputConfig: {
        placeholder: messages["app.customerLeads.dob"],
      },
      formItemConfig: {
        name: "dob",
        label: <IntlMessages id="app.customerLeads.dob" />,
      },
    },
    {
      type: AppInputType.SELECT,
      inputConfig: {
        placeholder: messages["app.customerLeads.gender"],
        options: [
          { value: 1, label: messages["app.customerLeads.gender.male"] },
          { value: 2, label: messages["app.customerLeads.gender.female"] },
          { value: 0, label: messages["app.customerLeads.gender.other"] },
        ],
      },
      formItemConfig: {
        name: "gender",
        label: <IntlMessages id="app.customerLeads.gender" />,
      },
    },
    {
      type: AppInputType.TEXT,
      inputConfig: {
        placeholder: messages["app.customerLeads.address"],
      },
      formItemConfig: {
        name: "address",
        label: <IntlMessages id="app.customerLeads.address" />,
      },
    },
    {
      type: AppInputType.TEXT,
      inputConfig: {
        placeholder: messages["app.customerLeads.city"],
      },
      formItemConfig: {
        name: "city",
        label: <IntlMessages id="app.customerLeads.city" />,
      },
    },
    {
      type: AppInputType.TEXT,
      inputConfig: {
        placeholder: messages["app.customerLeads.state"],
      },
      formItemConfig: {
        name: "state",
        label: <IntlMessages id="app.customerLeads.state" />,
      },
    },
    {
      type: AppInputType.TEXT,
      inputConfig: {
        placeholder: messages["app.customerLeads.zipcode"],
      },
      formItemConfig: {
        name: "zipCode",
        label: <IntlMessages id="app.customerLeads.zipcode" />,
      },
    },
    // Add more fields as needed
  ];
};

export default useConvertToUserModalFieldsConfig;
